import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { SimSettingsBusiness } from './SimSettingsBusiness';
import { SimSettingsConsumer } from './SimSettingsConsumer';
import { SimUsage } from './SimUsage';
import { SimNameForm } from './SimNameForm';
import { BillingPeriodSelect } from '../../components/BillingPeriodSelect';
import { OfferingType } from '../../utils/offeringType';
import { formatMsisdn } from '../../utils/helpers';

interface Props {
	accountType: string;
	id: string;
	name: string;
	msisdn: string;
	simNameChangeHandler: (simName: string) => void;
	newSimName: string;
	settings: any;
	onChange: (setting: any) => void;
	activeBillingPeriod: any;
	usageData: any;
	billingPeriods: any[];
	updateBillingPeriod: (billingPeriod: any) => void;
	offeringType: OfferingType;
	pollCurrentSim: () => void;
	phoneDirectoryUserInfo: any;
}

const Header = styled.div`
	text-align: center;
	margin-bottom: 2rem;

	@media screen and (min-width: 700px) {
		padding-top: 3rem;
		
		h2 {
			line-height: 1;
			margin-bottom: .5rem;
		}
	}
`;

const SimName = styled.h2`
	padding: 0;
	margin: 0.4em 0 0.2em;
	line-height: 1.2;
`;

const SimNumber = styled.div`
	font-size: 1.25em;
`;

const SettingsWrapper = styled.div`
	margin-top: 2rem;
`;

const SelectContainer = styled.div`
	max-height: 2rem;
	text-align: center;
	margin-top: 1em;
	margin-bottom: 2rem;

	@media screen and (min-width: 700px) {
		position: absolute;
		top: 20px;
		right: 20px;
		max-width: 15.5rem;
		margin-left: 1rem;
	}
`;

export const SimInfoContent: React.FC<Props> = (props: Props) => {
	const settingChecked: any = (setting: any) => (setting.latestChangeRequestValue !== undefined ? setting.latestChangeRequestValue : setting.value);

	return (
		<div style={{position: "relative"}}>
			{props.billingPeriods && (
				<SelectContainer>
					<BillingPeriodSelect billing={props.billingPeriods} selectedBillingPeriod={props.activeBillingPeriod || props.billingPeriods[0]} sendPeriod={props.updateBillingPeriod} />
				</SelectContainer>
			)}
			<Header>
				<SimName>{props.newSimName === '' ? props.name : props.newSimName}</SimName>
				<SimNumber>{formatMsisdn(props.msisdn)}</SimNumber>
			</Header>
			{!_.isNil(props.usageData) && <SimUsage usageData={props.usageData} renderAdditionalInfo={props.accountType === 'consumer'} />}
			<SimNameForm simName={props.name} onChange={props.simNameChangeHandler} />

			<SettingsWrapper>
				{props.accountType === 'business' && (
					<SimSettingsBusiness {...props} {...props.settings} onChange={(setting: any) => props.onChange({ settings: setting })} settingChecked={(setting: any) => settingChecked(setting)} />
				)}
				{props.accountType === 'consumer' && (
					<SimSettingsConsumer {...props} {...props.settings} onChange={(setting: any) => props.onChange({ settings: setting })} settingChecked={(setting: any) => settingChecked(setting)} />
				)}
			</SettingsWrapper>
		</div>
	);
};
